export default __webpack_public_path__ + "static/media/Snd_X_Starts.b68932a3.mp3";